import axios from '../base/axios';
import API_KEY from './key';

const GET_TVPOPULAR = 'flixfrenzy/redux/GET_TVPOPULAR';

// eslint-disable-next-line default-param-last
const tvPopularReducer = (state = [], action) => {
  switch (action.type) {
    case GET_TVPOPULAR:
      return action.payload;
    default:
      return state;
  }
};

export const getTvPopular = () => (dispatch) => {
  axios.get(`tv/popular?api_key=${API_KEY}&language=en-US`).then((res) => {
    dispatch({
      type: GET_TVPOPULAR,
      payload: res.data,
    });
  });
};

export default tvPopularReducer;
